module.exports = __webpack_public_path__ + "static/img/4.4df97c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/image/03/4/2/4.png
// module id = uSpr
// module chunks = 2